<app-loading *ngIf="contentReady"></app-loading>

<section class="bb-page">
  <div class="bb-page-shell">

    <header class="bb-page-header">
      <div class="bb-page-title-block">
                         <span class="bb-eyebrow">{{ 'Add Bundle' | transloco }}</span>
        <h2 class="bb-page-title">{{ 'Add Bundle' | transloco }}</h2>
      </div>
    </header>

    <div class="bb-card bb-p-20">
      <form [formGroup]="data" (ngSubmit)="submit()">
        <div class="bb-form-grid">

          <!-- Basic Info -->
          <div class="bb-field">
            <label class="bb-label" for="name_ar">{{ 'Bundle Name ar' | transloco }}</label>
            <input
              class="bb-input"
              id="name_ar"
              formControlName="name_ar"
              placeholder="{{ 'Bundle Name ar' | transloco }}"
              [ngClass]="{
                'is-invalid': data.get('name_ar')?.touched && data.get('name_ar')?.invalid,
                'is-valid': data.get('name_ar')?.touched && data.get('name_ar')?.valid
              }"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="name_en">{{ 'Bundle Name' | transloco }}</label>
            <input
              class="bb-input"
              id="name_en"
              formControlName="name_en"
              placeholder="{{ 'Bundle Name' | transloco }}"
              [ngClass]="{
                'is-invalid': data.get('name_en')?.touched && data.get('name_en')?.invalid,
                'is-valid': data.get('name_en')?.touched && data.get('name_en')?.valid
              }"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="description_ar">{{ 'Description ar' | transloco }}</label>
            <input
              class="bb-input"
              id="description_ar"
              formControlName="description_ar"
              placeholder="{{ 'Description ar' | transloco }}"
              [ngClass]="{
                'is-invalid': data.get('description_ar')?.touched && data.get('description_ar')?.invalid,
                'is-valid': data.get('description_ar')?.touched && data.get('description_ar')?.valid
              }"
            />
          </div>

          <div class="bb-field">
            <label class="bb-label" for="description_en">{{ 'Description en' | transloco }}</label>
            <input
              class="bb-input"
              id="description_en"
              formControlName="description_en"
              placeholder="{{ 'Description en' | transloco }}"
              [ngClass]="{
                'is-invalid': data.get('description_en')?.touched && data.get('description_en')?.invalid,
                'is-valid': data.get('description_en')?.touched && data.get('description_en')?.valid
              }"
            />
          </div>

          <!-- Image Upload -->
          <div class="bb-field bb-field-full">
            <label class="bb-label bb-mb-8">
              {{ "image" | transloco }}
            </label>

            <div class="bb-upload-card">
              <input type="file" accept="image/*" (change)="onImageSelect($event)" #fileInput hidden />

              <div class="bb-upload-area" (click)="fileInput.click()">

                <!-- Placeholder -->
                <div *ngIf="!imagePreview" class="bb-upload-placeholder">
                  <span class="bb-upload-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect x="3" y="7" width="18" height="14" rx="3" stroke="#2A7DE1" stroke-width="2.5" />
                      <circle cx="12" cy="14" r="3.5" stroke="#2A7DE1" stroke-width="2.5" />
                      <path d="M8 7L9.5 5H14.5L16 7" stroke="#2A7DE1" stroke-width="2.5" />
                    </svg>
                  </span>

                  <p class="bb-upload-title">
                    {{ "upload image" | transloco }}
                  </p>

                  <small class="bb-upload-sub">
                    {{ 'PNG / JPG' | transloco }}
                  </small>
                </div>

                <!-- Preview -->
                <div *ngIf="imagePreview" class="bb-preview-container">
                  <img [src]="imagePreview" class="bb-preview-img" />

                  <button
                    type="button"
                    class="bb-btn bb-btn-secondary bb-btn-sm"
                    (click)="fileInput.click(); $event.stopPropagation()"
                  >
                    {{ "change image" | transloco }}
                  </button>
                </div>

              </div>
            </div>
          </div>

          <!-- Prices Section -->
          <div class="bb-field bb-field-full">
            <label class="bb-label">{{ 'Prices' | transloco }}</label>

            <div class="bb-form-grid">
              <div class="bb-field">
                <label class="bb-label" for="price">{{ 'price' | transloco }}</label>
                <input
                  class="bb-input"
                  matInput
                  type="number"
                  id="price"
                  formControlName="price"
                  placeholder="{{ 'price' | transloco }}"
                  [ngClass]="{
                    'is-invalid': data.get('price')?.touched && data.get('price')?.invalid,
                    'is-valid': data.get('price')?.touched && data.get('price')?.valid
                  }"
                />
              </div>

              <div class="bb-field">
                <label class="bb-label" for="pricea">{{ 'Page A' | transloco }}</label>
                <input
                  class="bb-input"
                  matInput
                  type="number"
                  id="pricea"
                  formControlName="pricea"
                  placeholder="{{ 'Page A' | transloco }}"
                  [ngClass]="{
                    'is-invalid': data.get('pricea')?.touched && data.get('pricea')?.invalid,
                    'is-valid': data.get('pricea')?.touched && data.get('pricea')?.valid
                  }"
                />
              </div>

              <div class="bb-field">
                <label class="bb-label" for="priceb">{{ 'B' | transloco }}</label>
                <input
                  class="bb-input"
                  matInput
                  type="number"
                  id="priceb"
                  formControlName="priceb"
                  placeholder="{{ 'B' | transloco }}"
                  [ngClass]="{
                    'is-invalid': data.get('priceb')?.touched && data.get('priceb')?.invalid,
                    'is-valid': data.get('priceb')?.touched && data.get('priceb')?.valid
                  }"
                />
              </div>

              <div class="bb-field">
                <label class="bb-label" for="pricec">{{ 'C' | transloco }}</label>
                <input
                  class="bb-input"
                  matInput
                  type="number"
                  id="pricec"
                  formControlName="pricec"
                  placeholder="{{ 'C' | transloco }}"
                  [ngClass]="{
                    'is-invalid': data.get('pricec')?.touched && data.get('pricec')?.invalid,
                    'is-valid': data.get('pricec')?.touched && data.get('pricec')?.valid
                  }"
                />
              </div>

              <div class="bb-field">
                <label class="bb-label" for="affiliationprice">{{ 'Affiliation' | transloco }}</label>
                <input
                  class="bb-input"
                  matInput
                  type="number"
                  id="affiliationprice"
                  formControlName="affiliationprice"
                  placeholder="{{ 'Affiliation' | transloco }}"
                  [ngClass]="{
                    'is-invalid': data.get('affiliationprice')?.touched && data.get('affiliationprice')?.invalid,
                    'is-valid': data.get('affiliationprice')?.touched && data.get('affiliationprice')?.valid
                  }"
                />
              </div>
            </div>
          </div>

          <!-- Product Picker -->
          <div class="bb-field bb-field-full">
            <div class="bb-chip-select">
              <label class="bb-label bb-chip-label">{{ 'select product' | transloco }}</label>

              <mat-form-field class="bb-chip-mat-field" appearance="outline">
                <mat-chip-grid #chipGrid class="bb-chip-grid-custom">
                  <mat-chip-row
                    *ngFor="let item of selectedProductsDetails; trackBy: trackByProduct"
                    (removed)="removeProduct(item.product.id)"
                    class="bb-chip-item bb-chip-item-product"
                  >
                    {{ item.product.name_ar }}

                    <button matChipRemove type="button" class="bb-chip-remove-btn">
                      X
                    </button>
                  </mat-chip-row>

                  <input
                    class="bb-chip-input"
                    matInput
                    placeholder="{{ 'select product' | transloco }}"
                    [value]="searchValue"
                    (input)="onSearchChange($event)"
                    [matAutocomplete]="auto"
                    [matChipInputFor]="chipGrid"
                  />
                </mat-chip-grid>
              </mat-form-field>
            </div>
          </div>

          <mat-autocomplete
            #auto="matAutocomplete"
            (optionSelected)="addProduct($event)"
            class="bb-chip-autocomplete-panel"
          >
            <mat-option *ngFor="let product of filteredProviders" [value]="product">
              {{ product.name_ar }} - {{ product.price }} {{ 'egpe' | transloco }}
            </mat-option>
          </mat-autocomplete>

          <!-- Selected Products Table -->
          <div *ngIf="selectedProductsDetails.length > 0" class="bb-field bb-field-full">
            <label class="bb-label">{{ 'Selected Products' | transloco }}</label>

            <div class="bb-table-scroll">
              <table class="bb-table bb-native-table">
                <thead>
                  <tr>
                    <th>{{ 'Product' | transloco }}</th>
                    <th>{{ 'price' | transloco }}</th>
                    <th>{{ 'quantity' | transloco }}</th>
                    <th>{{ 'total' | transloco }}</th>
                  </tr>
                </thead>

                <tbody>
                  <tr *ngFor="let item of selectedProductsDetails; trackBy: trackByProduct">
                    <td>{{ item.product.name_ar }}</td>
                    <td>{{ item.product.price }}</td>
                    <td>
                      <input
                        type="number"
                        min="1"
                        class="bb-input"
                        [(ngModel)]="item.quantity"
                        [ngModelOptions]="{standalone:true}"
                      />
                    </td>
                    <td>{{ item.product.price * item.quantity }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <!-- Cost & Profit Summary -->
            <div class="bb-card bb-bg-soft bb-border bb-p-16 bb-mt-16">
              <h4 class="bb-m-0 bb-mb-12 bb-text-blue bb-font-bold">
                {{ 'total' | transloco }}: {{ totalCost | number:'1.0-2' }} {{ 'egpe' | transloco }}
              </h4>

              <div class="bb-form-grid">
                <p
                  class="bb-m-0 bb-font-semibold"
                  [ngClass]="profitFor(data.value.price) >= 0 ? 'bb-text-success' : 'bb-text-danger'"
                >
                  {{ 'Main Profit' | transloco }}: {{ profitFor(data.value.price) | number:'1.0-2' }}
                </p>

                <p
                  class="bb-m-0 bb-font-semibold"
                  [ngClass]="profitFor(data.value.pricea) >= 0 ? 'bb-text-success' : 'bb-text-danger'"
                >
                  {{ 'Profit A:' | transloco }} {{ profitFor(data.value.pricea) | number:'1.0-2' }}
                </p>

                <p
                  class="bb-m-0 bb-font-semibold"
                  [ngClass]="profitFor(data.value.priceb) >= 0 ? 'bb-text-success' : 'bb-text-danger'"
                >
                  {{ 'Profit B:' | transloco }} {{ profitFor(data.value.priceb) | number:'1.0-2' }}
                </p>

                <p
                  class="bb-m-0 bb-font-semibold"
                  [ngClass]="profitFor(data.value.pricec) >= 0 ? 'bb-text-success' : 'bb-text-danger'"
                >
                  {{ 'Profit C:' | transloco }} {{ profitFor(data.value.pricec) | number:'1.0-2' }}
                </p>

                <p
                  class="bb-m-0 bb-font-semibold"
                  [ngClass]="profitFor(data.value.affiliationprice) >= 0 ? 'bb-text-success' : 'bb-text-danger'"
                >
                  {{ 'Affiliation Profit' | transloco }}: {{ profitFor(data.value.affiliationprice) | number:'1.0-2' }}
                </p>
              </div>
            </div>
          </div>

          <!-- Submit -->
          <div class="bb-field bb-field-full bb-mt-16">
            <button class="bb-btn bb-btn-primary bb-w-100" [disabled]="data.invalid || selectedProductsDetails.length === 0">
              {{ 'Submit' | transloco }}
            </button>
          </div>

        </div>
      </form>
    </div>

  </div>
</section>